type ConfirmApi = {
  confirm: (config: {
    title: string;
    content: string;
    okText: string;
    cancelText?: string;
    onOk: () => void;
  }) => void;
};

export const confirmDiscardUnsaved = (
  modal: ConfirmApi,
  labels: {
    title: string;
    content: string;
    okText: string;
    cancelText: string;
  },
  onConfirm: () => void,
) => {
  modal.confirm({
    title: labels.title,
    content: labels.content,
    okText: labels.okText,
    cancelText: labels.cancelText,
    onOk: onConfirm,
  });
};
